import React from 'react';

import AdminToolbar from '../admin/admin_toolbar';
import { Card } from '@buildoutinc/blueprint-react/ui/Card';
import { Conversation } from '../conversation';
import { NextActionsProvider, useNextActionsContext, withNextActions } from '../next_actions_context';
import { PinnedRecommendations } from '../tools/inline/recommendation_cards';
import { ConversationProvider, useConversationContext } from '../conversation_context';
import { DropOverlay } from '../drop_overlay';
import { MobileHeader } from './header';
import { StandaloneTools } from '../tools/standalone';
import { ToolsProvider } from '../tools/context';
import { useVisualViewport } from './use_visual_viewport';

import type { Agent, Paths } from '../types';

interface Props {
  agents: Agent[];
  currentUser: {
    admin: boolean;
    firstName?: string | null;
  };
  logoPath: string;
  paths: Paths;
}

export function AiMobileAssistant({ agents, currentUser, logoPath, paths }: Props) {
  return (
    <ToolsProvider>
      <NextActionsProvider>
        <MobileConversation agents={agents} currentUser={currentUser} logoPath={logoPath} paths={paths} />
      </NextActionsProvider>

      <StandaloneTools/>
    </ToolsProvider>
  );
}

function MobileConversation({ agents, currentUser, logoPath, paths }: Props) {
  const nextActions = useNextActionsContext();

  return (
    <ConversationProvider
      agents={agents}
      firstName={currentUser.firstName}
      isAdmin={currentUser.admin}
      // No page here: there is none worth telling the agent about, and it has no navigate tool
      pageContext={withNextActions(nextActions)}
      paths={paths}
    >
      <MobilePanel logoPath={logoPath} />
    </ConversationProvider>
  );
}

function MobilePanel({ logoPath }: { logoPath: string }) {
  const { getRootProps, isDragActive } = useConversationContext();
  const viewport = useVisualViewport();

  return (
    // Pinned to the visual viewport rather than sized in the flow, so the body's own margins can't
    // push the composer off a phone screen
    <div className="ai-assistant-mobile position-fixed start-0 end-0" style={viewport}>
      <Card className="ai-assistant d-flex flex-column h-100 overflow-hidden" {...getRootProps()}>
        {isDragActive && <DropOverlay/>}

        <MobileHeader logoPath={logoPath} />
        <AdminToolbar />
        <Conversation pinned={<PinnedRecommendations />} />
      </Card>
    </div>
  );
}
